// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__meJDr","container":"styles_container__2lXUd","bg":"styles_bg__20gUg"};